/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectPenaltyCommandResult } from '../../models/create-project-penalty-command-result';

export interface ApiProjectPenaltiesCreateProjectPenaltyPost$Plain$Params {
      body?: {
'PenaltyDetailsId'?: string;
'PenaltyName'?: string;
'PenaltyCode'?: string;
'PenaltyValue'?: number;
'PenaltyDate': string;
'Count'?: number;
'ProjectId'?: string;
'SavePenaltyToSystem'?: boolean;
'PenaltyId'?: string;
'Attachments'?: Array<Blob>;
}
}

export function apiProjectPenaltiesCreateProjectPenaltyPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectPenaltiesCreateProjectPenaltyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectPenaltyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectPenaltiesCreateProjectPenaltyPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectPenaltyCommandResult>;
    })
  );
}

apiProjectPenaltiesCreateProjectPenaltyPost$Plain.PATH = '/api/ProjectPenalties/CreateProjectPenalty';
